import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { RefreshCw, AlertCircle, Mail } from "lucide-react";
import { Link } from "@tanstack/react-router";

export const Route = createFileRoute("/(public)/stripe/refresh")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="text-center max-w-lg mx-auto px-4">
        <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
          <RefreshCw className="w-12 h-12 text-blue-600" />
        </div>

        <h1 className="font-h1 text-blue-600 mb-4 text-3xl">
          Configuration de votre compte Stripe
        </h1>

        <p className="font-p text-muted-foreground mb-6 text-lg">
          La configuration de votre compte de paiement a été interrompue ou a
          expiré.
        </p>

        <div className="bg-white p-6 rounded-lg shadow-md mb-8 border border-blue-200">
          <div className="flex items-center justify-center gap-2 mb-3">
            <AlertCircle className="w-5 h-5 text-blue-600" />
            <span className="font-semibold text-blue-700">
              Configuration requise
            </span>
          </div>
          <p className="text-sm text-muted-foreground">
            Pour recevoir des paiements en tant que chef, vous devez finaliser
            la configuration de votre compte Stripe.
          </p>
        </div>

        <p className="font-p text-muted-foreground mb-8">
          Vous pouvez reprendre la configuration maintenant ou la compléter plus
          tard depuis votre dashboard.
        </p>

        <div className="space-y-4">
          <Button asChild className="w-full">
            <Link to="/dashboard">
              <RefreshCw className="w-4 h-4 mr-2" />
              Reprendre la configuration
            </Link>
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to="/contact">
              <Mail className="w-4 h-4 mr-2" />
              Contacter le support
            </Link>
          </Button>
        </div>

        <p className="text-xs text-muted-foreground mt-6">
          Vous pouvez compléter cette étape à tout moment depuis votre tableau
          de bord chef.
        </p>
      </div>
    </div>
  );
}
